<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          变电站设备音频指纹特征采集和诊断分析系统
        </div>
        <div class="txt">
          Substation equipment audio fingerprint feature collection and diagnostic analysis system
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>“变电站设备音频指纹特征采集和诊断分析系统研究”的研究成果由国网上海市电力公司市北供电公司运检部于2019年1月起在钱湾
站配电室内部署应用。</p>
          <p>
       本项目主要解决了运检人员无法实时监控无人值守变电站现场设备运行情况的问题。在研究成果应用过程中，音频处理平台可及时获取变电站电力设备运行声信号并通过软件进行存储和音频数据分析，识别站内电力设备和系统的正常/异常状态，并在硬件采集平台的界面上显示报警信息。达到了在无人值守的情况下，实时监测变电站现场设备状况的作用，保障了变电站现场设备的正常运行，提升了变电站现场设备的运行效率。</p>
        </div> 
      </div>
      <div>
        <div class="title">产品图片</div> 
        <div class="img_one">
          <div class="list_one one">
            <img src="../assets/pic63.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one one" style="marginTop: 10px">
            <img src="../assets/pic64.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/pic65.png" alt="">
          </div>
          <div class="list_one">
            <img src="../assets/pic66.png" alt="">
          </div>
        </div> 
      </div>
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 280px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one .one img {
  width: 1000px;
  height: 450px;
}
.img_one img {
  width: 430px;
  height: 380px;
}
.img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}


.detail_foot {
  margin-top: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail9.vue